class BookSummary {
    /**
     * A Model representing the book summary for the current book.
     * @param {JS Object} summary Contains the Annotation information for the book.
     * @param {string} bookTitle Title of the book
     * @param {bookJacketUrl} bookJacketUrl Book jacket of the current book.
     */
    constructor(summary, bookTitle, bookJacketUrl){
        this.summary = summary.Annotation;
        this.bookTitle = bookTitle;
        this.bookJacketUrl = bookJacketUrl;
    }   
}

export default BookSummary;


// WEBPACK FOOTER //
// ./src/models/BookSummary.js